import { AuthContext } from 'context/authContext/AuthContext';
import { WSO2AuthLocalStorageNames } from 'helpers/enums/WSO2AuthLocalStorageNames';
import { getApiEndpoint } from 'library/Apis';
import { AssociadoRoutePath, MainRoutePath } from 'library/Routes';
import { UserManager, WebStorageStateStore } from 'oidc-client';
import { useContext, useLayoutEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { authActionsLogin } from 'store/modules/AuthActions';

export default function AssociadoArea({ children }: any) {
  const history = useHistory();
  const {
    user,
    setUser,
    manager,
    login,
    logout,
    currentEnv,
    startInterceptor,
    setLoading,
  } = useContext(AuthContext);
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    if (typeof login === 'function' && currentEnv) {
      login(
        new UserManager({
          ...currentEnv.authAssociado,
          automaticSilentRenew: true,
          userStore: new WebStorageStateStore({ store: window.sessionStorage }),
          clockService: {
            getEpochTime: async () => {
              return fetch(
                `${getApiEndpoint('eventoAssociado')}evento/current-epoch`,
                { method: 'GET' }
              )
                .then((response) => response.text())
                .then((text) => parseInt(text));
            },
          },
        })
      );
      // makeAuthenticator
      // login!(new UserManager(getWSO2UserManagerSettings(currentEnv!?.auth)));
    }
  }, [currentEnv, login]);

  useLayoutEffect(() => {
    if (manager) {
      setLoading!('Carregando as informações do usuário');
      manager
        .signinRedirectCallback()
        .then((user) => {
          const hasState = window.location.href.match(/state=([^&]*)/);
          if (hasState) {
            const redirectUrl = sessionStorage.getItem(
              WSO2AuthLocalStorageNames.RedirectUri
            );
            history.replace(redirectUrl || AssociadoRoutePath);
          }
          setUser!(user);
        })
        .catch(() => {
          setLoading!(false);
          sessionStorage.setItem(
            WSO2AuthLocalStorageNames.RedirectUri,
            window.location.pathname
          );
          manager?.signinRedirect();
        });
      manager.events.addSilentRenewError(() => {
        logout!()!?.finally(() => {
          history!?.push(MainRoutePath);
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manager]);

  useLayoutEffect(() => {
    startInterceptor!(() => {
      dispatch(
        authActionsLogin(
          user!.access_token,
          () => {
            setLoading!(false);
          },
          () => {
            setLoading!(false);
          }
        )
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const content = useMemo(() => {
    if (user) {
      return children;
    } else {
      return null;
    }
  }, [user, children]);

  return content;
}
